<script lang="ts">
  import { onMount } from "svelte";
  import Timeslot from "./Timeslot.svelte";

  export let end_date_time: Date;
  export let title: string;

  let endtime = new Date(end_date_time).getTime();

  let total = 0;
  let days = 0;
  let hours = 0;
  let minutes = 0;
  let seconds = 0;

  onMount(() => {
    calculateTimeRemaining();
  });

  function calculateTimeRemaining() {
    total = endtime - new Date().getTime();
    days = Math.floor(total / (1000 * 60 * 60 * 24));
    hours = Math.floor((total % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    minutes = Math.floor((total % (1000 * 60 * 60)) / (1000 * 60));
    seconds = Math.floor((total % (1000 * 60)) / 1000);
  }

  let clear;
  export let show_on_mobile = false;

  $: {
    clearInterval(clear);
    clear = setInterval(calculateTimeRemaining, 1000);
  }
</script>

{#if total > 0}
  <div
    class={`${show_on_mobile ? "flex" : "hidden md:flex"} flow-hidden  flex flex-col justify-center items-center w-full`}
  >
    <div class="w-full max-w-sm-screen md:p-4">
      <h3 class="text-white font-medium text-h3 mb-2 md:mb-6">{title}</h3>
      <div
        role="timer"
        aria-atomic="true"
        aria-live="polite"
        class="flex flex-row gap-4 w-full leading-none"
      >
        <Timeslot time={days} label="Days" divider=":" />
        <Timeslot time={hours} label="Hours" divider=":" />
        <Timeslot time={minutes} label="Minutes" divider=":" />
        <Timeslot time={seconds} label="Seconds" />
      </div>
    </div>
  </div>
{/if}
